<ul>
  <li>
    <ion-button fill="clear" (click)="onHomeMenuClick($event)">
      <ion-icon slot="start" name="home-outline" class="home"></ion-icon>
      <span *ngIf="!this.forCustomer && restaurantId" class="ion-text-capitalize" [innerText]="restaurant?.name"></span>
      <ion-icon slot="end" name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </li>
  <li *ngFor="let menu of menus; let i = index">
    <ion-button class="ion-text-capitalize" fill="clear" (click)="onMenuClick($event, menu, i)"
      [disabled]="i === menus.length - 1">
      <span [innerText]="menu.name"></span>
      <ion-icon slot="end" name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </li>
</ul>
